export const OFFLINE_HANDLERS = {
  patient: {
    create: async (body) => {
      const { createPatientOffline } = await import("./../Patients")
      return await createPatientOffline(body)
    },
  },
  appointment: {
    create: async (body) => {
      const { createAppointmentOffline } = await import("./../Appointments")
      return await createAppointmentOffline(body)
    },
  },
  reminder: {
    create: async (body) => {
      const { createReminderOffline } = await import("./../Reminders")
      return await createReminderOffline(body)
    },
  },
  user: {
    create: async (body) => {
      const { createUserOffline } = await import("./../Users")
      return await createUserOffline(body)
    },
  },
  bilan: {
    create: async (body) => {
      const { createBilanOffline } = await import("./../Bilans")
      return await createBilanOffline(body)
    },
  },
  expenses: {
    create: async (body) => {
      const { createExpenseOffline } = await import("./../Expenses")
      return await createExpenseOffline(body)
    },
  },
  consultation: {
    addPayment: async (_body, _path) => {
      // Tu peux déplacer ton code addPayment ici plus tard
    },
  },
  doctorOffice: {
    editMyProfil: async (body) => {
      const { editMyProfilOffline } = await import("./../Profile")
      return await editMyProfilOffline(body)
    },
  },
}
